package presentation.screens.appInfo

import com.kinoshazam.Navigator
import com.kinoshazam.config.getPlatformConfig
import org.koin.core.component.KoinComponent
import utils.BaseViewModel

class AppInfoViewModel(
    private val navigator: Navigator,
) : BaseViewModel<AppInfoState, AppInfoMVIAction>(), KoinComponent {

    override fun initState(): AppInfoState = AppInfoState(
        mainText = "",
        appVersion = getPlatformConfig().version
    )

    override fun onAction(action: AppInfoMVIAction) {
        when (action) {
            is AppInfoMVIAction.onBackClicked -> navigator.back()
        }
    }
}
